import request from '../utils/request'

export function getBase64Media(uuid) {
    return request.get('/media/' + uuid + '/base64')
}
